import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { convertEmptyField } from 'utils/formatters';


export interface BaseLabelProps {
  text: string | number | undefined | null;
  backgroundColor?: string;
}

const BaseLabel = ({ text, backgroundColor = '#FF9800' }: BaseLabelProps) => {
  const displayValue = convertEmptyField(text);

  if (displayValue === 'n/a') {
    return <Typography color="textSecondary">{displayValue}</Typography>
  }

  return (
    <Box
      display="inline-block"
      px={4}
      py={0.25}
      fontSize="1rem"
      borderRadius={4}
      fontWeight={600}
      color="#fff"
      style={{ backgroundColor }}
    >
      {displayValue}
    </Box>
  );
};

export default BaseLabel;